import { FC } from 'react';
import { useRecoilState } from 'recoil';
import myInfoState from '../../atoms/myinfo';
import waitingRoomState from '../../atoms/waiting-room';
import './Room.scoped.scss';
import { openAlert, openConfirm } from '../../atoms/common';
import { ProjectStatus } from '../../atoms/roomDetail';
import LockIcon from "../../assets/img/lock_icon.png";

interface RoomProps {
  thumbnailUrl: string;
  name: string;
  participants: number;
  maxParticipants: number;
  ownerLevel: number;
  ownerName: string;
  roomId: string;
  isSecret: boolean;
  isProject: boolean;
  projectStatus: ProjectStatus;
  projectType: string;
  projectStartAmount: number;
  projectTargetAmount: number;
  projectAmount: number;
  projectPrice: number;
  projectParticipants: string[];
  record: { win: number; defeat: number; };
  ownerDecorationItem: boolean;
  ownerMaxStreak: number;
  recommendersCount: number;
}

const Room: FC<RoomProps> = ({
  thumbnailUrl,
  name,
  participants,
  maxParticipants,
  ownerLevel,
  ownerName,
  roomId,
  isSecret,
  isProject,
  projectStatus,
  projectType,
  projectStartAmount,
  projectTargetAmount,
  projectAmount,
  projectPrice,
  projectParticipants,
  record,
  ownerDecorationItem,
  ownerMaxStreak,
  recommendersCount,
}) => {
  const streak5n = Math.floor(ownerMaxStreak / 5) * 5;

  const [myInfo] = useRecoilState(myInfoState);
  const [waitingRoom, setWaitingRoom] = useRecoilState(waitingRoomState);

  const _enterRoom = () => {
    if (!isSecret) {
      window.location.href = `/chatting-app/room/${roomId}`;
    } else {
      setWaitingRoom({
        ...waitingRoom,
        isOpenedEnteringSecretRoom: true,
        tryingRoomId: roomId
      });
    }
  };

  const enterRoom = () => {
    if (myInfo.userDetail == null || myInfo.userDetail.id === '') {
      openAlert('로그인 후 이용해주세요.');
      return;
    }
    if (projectStatus === ProjectStatus.PLAY && !projectParticipants.find((v) => v === myInfo.userDetail?.id)) {
      openConfirm(
        `해당 프리미엄 방의 참가비는 ${projectPrice.toLocaleString()}보석입니다.<br/>정말 참가하시겠습니까?`,
        () => {
          _enterRoom();
        }
      );
      return;
    }
    _enterRoom();
  };

  return (
    <div className="room">
      <div>
        <img className="room__thumbnail" src={thumbnailUrl} alt="" />
      </div>
      <div className="room__title-and-participants">
        <div>
          <div className="room__title">
            {name}
            {isSecret ? (
              <span className="room__secret-simbol"><img src={LockIcon} alt="[비밀방]"></img></span>
            ) : null}
            {isProject ? (
              <span className="room__secret-simbol">[프리미엄방]</span>
            ) : null}
            {/* <span style={{ fontSize: 10 }}>
              [<span style={{ color: 'rgb(46, 131, 255)' }}>{record.win}</span>승 <span style={{ color: 'rgb(236, 32, 36)' }}>{record.defeat}</span>패]
            </span> */}
            {
              ownerDecorationItem && streak5n ? (
                <span style={{
                  fontSize: 10,
                  color: '#fff',
                  borderRadius: 5,
                  background: '#ff5454',
                  padding: 4,
                  fontWeight: 'bold',
                }}>
                  {streak5n}연승
                </span>
              ) : null
            }
          </div>
          <div className="room__participants">
            <b>{participants}</b> / {maxParticipants}
          </div>
        </div>
        <div className="room__time-left">
            좋아요 {recommendersCount}명
        </div>
        <div className="room__time">
          {
            isProject ? (
              <>
                {projectStatus === ProjectStatus.PLAY ? (
                  <>
                    {`타입: ${projectType}`} / {`시작: ${Math.floor(projectStartAmount / 10000)}만`} / {`목표: ${Math.floor(projectTargetAmount / 10000)}만`} / {`현재: ${Math.floor(projectAmount / 10000)}만`}
                  </>
                ) : '프리미엄 시작 대기'}
              </>
            ) : (
              <>
                {projectType ? `게임 타입: ${projectType}` : ''}
              </>
            )
          }
        </div>
      </div>
      <div className="room__profile-and-enter-button">
        <div className="room__profile">
          <img src={`/img/level/zb4/${ownerLevel}.gif`} alt="" />
          <span>{ownerName}</span>
        </div>
        <div className="room__enter-button">
          <button onClick={enterRoom}>입장하기</button>
        </div>
      </div>
    </div>
  );
};

export default Room;
